import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateRegionsInput,
    Regions,
    UpdateRegionsInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class RegionsService {
    private amplifyClient = generateClient();

    constructor() {}

    async listRegions(limit: number = 200): Promise<Regions[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listRegions,
                    variables: { limit }
                })
            ).data.listRegions.items;
            if (data) return data as Regions[];
        } catch (error) {
            console.error('Error finding Regions:', error);
            return null;
        }
    }

    async createRegions(input: CreateRegionsInput): Promise<Regions> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createRegions,
                    variables: {
                        input
                    }
                })
            ).data.createRegions;
            if (data) return data as Regions;
        } catch (error) {
            console.error('Error creating Regions:', error);
            return null;
        }
    }

    async updateRegions(input: UpdateRegionsInput): Promise<Regions> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateRegions,
                    variables: {
                        input
                    }
                })
            ).data.updateRegions;
            if (data) return data as Regions;
        } catch (error) {
            console.error('Error creating Regions:', error);
            return null;
        }
    }
}
